var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 60,
    viewBox: "0 0 53 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.25 6.66683H6.08333V53.3335H46.9167V18.3335H35.25V6.66683ZM0.25 3.72683C0.25 2.1285 1.55375 0.833496 3.16375 0.833496H38.1667L52.75 15.4168V56.2297C52.7527 56.6128 52.6799 56.9926 52.5358 57.3475C52.3917 57.7024 52.1791 58.0254 51.9102 58.2981C51.6412 58.5709 51.3212 58.788 50.9684 58.937C50.6155 59.0861 50.2368 59.1642 49.8538 59.1668H3.14625C2.38027 59.1615 1.64713 58.855 1.10522 58.3137C0.563302 57.7723 0.256109 57.0395 0.25 56.2735V3.72683ZM29.4167 30.0002V41.6668H23.5833V30.0002H14.8333L26.5 18.3335L38.1667 30.0002H29.4167Z",
    fill: "#FFC10E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFileIcon);
export default __webpack_public_path__ + "static/media/uploadFileIcon.f4b3cbcecca6ac46629ab74c7a1e1c4f.svg";
export { ForwardRef as ReactComponent };